/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard} from '../../../../../../../../../../_metronic/helpers'
import {EquipmentByPointModel} from '../../../../../../model'
import {getAssignMachine} from '../../../../../../services'
import {deleteAssignMachine} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ModalAddMachine} from '../modal/ModalAddMachine'
import Swal from 'sweetalert2'

const TableMachine: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, selectedOn, pagination} =
    useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [detailpermission, setDetailPermission] = useState<EquipmentByPointModel | any>(null)

  const handleClear = () => {
    setIdPermission('')
  }
  const getAssignMachineList = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getAssignMachine(
        currentTabItem.idToEdit,
        pagination.currentPage,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getAssignMachineList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getAssignMachineList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<EquipmentByPointModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombre' />,
      accessor: 'nombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Marca' />,
      accessor: 'marca',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Modelo' />,
      accessor: 'modelo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Serie' />,
      accessor: 'serie',
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        // const mappedSelected = selected.map((item) => ({Id: item}))

        let obj = {
          puntoId: currentTabItem.idToEdit,
          machines: [selectedOn[0]],
        }
        const {data: response} = await deleteAssignMachine(obj)
        if (!response.error) {
          getAssignMachineList()
        }
        getAssignMachineList()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {isAllowed('ASIGMAQUINARIA/AGREGAR') && (
            <button type='button' className='btn btn-success me-3' onClick={handleNew}>
              Agregar
            </button>
          )}
          {isAllowed('ASIGMAQUINARIA/ELIMINAR') && (
            <button
              type='button'
              className='btn btn-primary me-3'
              disabled={selectedOn.length < 1}
              onClick={handleDelete}
            >
              Eliminar
            </button>
          )}
        </div>
        {isAllowed('ASIGMAQUINARIA/LISTAR') && (
          <>
            <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}

        <ModalAddMachine
          show={showModalNew}
          setShow={setShowModalNew}
          getAssignMachineList={getAssignMachineList}
          detailpermission={detailpermission}
          idPermission={idPermission}
          setIdPermissionList={handleClear}
        />
      </KTCard>
    </>
  )
}

const TableMachineWrapper = () => {
  return (
    <KTableProvider>
      <TableMachine />
    </KTableProvider>
  )
}
export {TableMachineWrapper}
